import React, { useState } from 'react'
import FeatherIcon from 'feather-icons-react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap'
import OriginAddress from './OriginAddress';
import HandleFee from './HandleFee';
import Shipping from './Shipping/Shipping';
import LoadingSkeleton from './LoadingSkeleton';
import LocalDelivery from './LocalDelivery/LocalDelivery';
import PickUp from './Pickup/PickUp';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

const ShippingRow = ({ item, addShipping_, deleteShipping }) => {
    const [enabled, setEnabled] = useState("" + item.status === "1")
    const e = item
    let rate = "free"
    if (e.shipping_type === "free_shipping") {
        rate = "free"
    } else if (e.shipping_type === "conditional_free_shipping") {
        const a = e.shippingrates[0] || {}
        rate = "$" + (a.rate_per_item || a.rate_per_lbs || 0)
    } else if (e.shipping_type === "flat_rate") {
        const a = e.shippingrates[0] || {}
        e.amount_type = a.amount_type
        e.amount = a.amount

        if (e.amount_type === "flat") {
            rate = `$${e.amount || "00.0"}`
        } else {
            rate = `${e.amount || "0"}%`
        }
    } else {
        const a = e.shippingrates[0] || {}
        rate = "$" + (a.rate_per_item || a.rate_per_lbs || 0)
    }

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <div className="app-card mb-4" key={item.id}>
            <div className={`product-filter-card ${enabled === false ? "disabled-criteria" : ""}`}>
                <div className="card-content">
                    <div className="d-flex align-items-center">
                        <div className="card-icon" >
                            <span className="icon_">
                                {
                                    (item.shipping_type) === "free_shipping" && (
                                        <svg width={56} height={56} viewBox="0 0 55 55" xmlns="http://www.w3.org/2000/svg" focusable="false"><g fill="none" fillRule="evenodd"><path fill="#CBE87C" d="M27.245 50.125l-6.964 3.12-4.476-6.184-7.596-.78-.78-7.596-6.184-4.476 3.12-6.964-3.12-6.964 6.184-4.476.78-7.596 7.596-.78 4.476-6.184 6.964 3.12 6.964-3.12 4.476 6.184 7.596.78.78 7.596 6.184 4.476-3.12 6.964 3.12 6.964-6.184 4.476-.78 7.596-7.596.78-4.476 6.184z" /><path stroke="#7E94AA" strokeWidth={2} d="M27.245 50.125l-6.964 3.12-4.476-6.184-7.596-.78-.78-7.596-6.184-4.476 3.12-6.964-3.12-6.964 6.184-4.476.78-7.596 7.596-.78 4.476-6.184 6.964 3.12 6.964-3.12 4.476 6.184 7.596.78.78 7.596 6.184 4.476-3.12 6.964 3.12 6.964-6.184 4.476-.78 7.596-7.596.78-4.476 6.184z" /><path d="M13.325 33.235h-2.08v-9.99h5.73v1.74h-3.64v2.58h3.39v1.73h-3.39v3.94h-.01zm7.72-5.56h.68c.67 0 1.17-.11 1.48-.33.31-.22.48-.57.48-1.05 0-.47-.16-.81-.49-1.01-.33-.2-.83-.3-1.51-.3h-.64v2.69zm0 1.73v3.83h-2.12v-9.99h2.91c1.36 0 2.36.25 3.01.74.65.49.98 1.25.98 2.25 0 .59-.16 1.11-.49 1.57-.33.46-.78.82-1.37 1.08 1.5 2.25 2.48 3.7 2.94 4.35h-2.35l-2.39-3.83h-1.12zm12.88 3.83h-5.76v-9.99h5.76v1.74h-3.64v2.19h3.38v1.74h-3.38v2.58h3.64v1.74zm7.84 0h-5.76v-9.99h5.76v1.74h-3.64v2.19h3.38v1.74h-3.38v2.58h3.64v1.74z" fill="#7E94AA" /><path d="M26.245 9.245a1 1 0 102 0 1 1 0 00-2 0z" stroke="#7E94AA" strokeWidth={2} /></g></svg>
                                    )
                                }
                                {
                                    (item.shipping_type) === "conditional_free_shipping" && (
                                        <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} viewBox="0 0 56 56" focusable="false"><defs><clipPath id="a"><path d="M36 18.5A17.5 17.5 0 1018.5 36c.56 0 1.11 0 1.65-.08l15.77-15.77c0-.54.08-1.09.08-1.65" fill="none" clipRule="evenodd" /></clipPath><clipPath id="b"><path d="M18.82 17.37c-1.56 0-2.72-.81-2.72-1.54s1.16-1.55 2.72-1.55 2.72.82 2.72 1.55a1.16 1.16 0 102.32 0c0-1.86-1.63-3.38-3.88-3.77V10.8a1.16 1.16 0 10-2.32 0v1.26c-2.25.39-3.88 1.91-3.88 3.77 0 2.16 2.21 3.86 5 3.86.29 0 2.72.82 2.72 1.55s-1.17 1.55-2.72 1.55-2.68-.79-2.68-1.55a1.16 1.16 0 00-2.32 0c0 1.86 1.63 3.37 3.88 3.77v1.26a1.16 1.16 0 102.32 0V25c2.25-.4 3.88-1.91 3.88-3.77 0-2.17-2.22-3.87-5-3.87" fill="none" clipRule="evenodd" /></clipPath><clipPath id="c"><path fill="none" clipRule="evenodd" d="M37 52.76l-4.82 2.15-3.1-4.27-5.26-.54-.54-5.24L19 41.77l2.16-4.82-2.16-4.8 4.28-3.1.54-5.24 5.26-.54 3.1-4.27L37 21.16 41.82 19l3.1 4.27 5.26.54.54 5.24 4.28 3.1-2.16 4.8L55 41.77l-4.28 3.09-.54 5.24-5.26.54-3.1 4.27L37 52.76z" /></clipPath><clipPath id="d"><path d="M48 40h-4.15v-6H48v1h-2.62v1.31h2.43v1h-2.43V39H48zm-5.65 0H38.2v-6h4.15v1h-2.63v1.31h2.44v1h-2.44V39h2.63zm-9.29-2.3V40h-1.52v-6h2.09a4.22 4.22 0 012.17.44 1.52 1.52 0 01.71 1.36 1.44 1.44 0 01-.35.94 2.38 2.38 0 01-1 .65c1.09 1.35 1.84 2.22 2.13 2.61h-1.7l-1.72-2.3zm0-1h.49a2.2 2.2 0 001.07-.2.69.69 0 00.35-.63.62.62 0 00-.36-.6 2.45 2.45 0 00-1.08-.18h-.47zM27.5 40H26v-6h4.13v1h-2.62v1.54H30v1h-2.49V40z" fill="none" clipRule="evenodd" /></clipPath></defs><g clipPath="url(#a)"><path fill="#fbd88e" d="M-2.57-2.57h42.14v42.14H-2.57z" /></g><path d="M18.5 37A18.5 18.5 0 1137 18.5c0 .56 0 1.14-.08 1.74v.36L20.6 36.88h-.36c-.59.12-1.18.12-1.74.12zm0-35a16.5 16.5 0 000 33h1.2L35 19.7v-1.2A16.52 16.52 0 0018.5 2z" fill="#7e94aa" /><g clipPath="url(#b)"><path fill="#d8ab50" d="M10.21 6.07h17.22V31H10.21z" /></g><path d="M18.5 33A14.5 14.5 0 1133 18.5 14.51 14.51 0 0118.5 33zm0-27A12.5 12.5 0 1031 18.5 12.52 12.52 0 0018.5 6z" fill="#d8ab50" /><g clipPath="url(#c)"><path fill="#cbe87c" d="M15.54 15.55h42.92v42.82H15.54z" /></g><g clipPath="url(#d)"><path fill="#7e94aa" d="M22.4 31h29.21v12.01H22.4z" /></g><path d="M42.15 56L37 53.85 32 56l-3.43-4.4-5.66-.6-.58-5.61-4.58-3.3L20.06 37l-2.31-5.15 4.58-3.3.58-5.61 5.62-.58 3.32-4.56L37 20.06l5.15-2.3 3.32 4.56 5.62.58.58 5.61 4.33 3.3L53.94 37 56 42.1l-4.33 3.3-.58 5.6-5.62.58zM37 51.66l4.49 1.85 2.88-3.82 4.9-.5.5-4.88 3.74-2.88L51.74 37l1.77-4.48-3.74-2.92-.5-4.88-4.9-.5-2.88-4-4.49 2-4.49-2-2.88 4-4.9.5-.5 4.88-4 2.88 2 4.48-2 4.47 4 2.88.5 4.88 4.9.5 3 3.81z" fill="#7e94aa" /><circle cx={37} cy={26} r={1} fill="#7e94aa" /></svg>
                                    )
                                }
                                {
                                    (item.shipping_type) === "flat_rate" && (
                                        <svg width={56} height={56} viewBox="0 0 51 51" xmlns="http://www.w3.org/2000/svg" focusable="false"><g fill="none" fillRule="evenodd"><path d="M50 25.5C50 11.969 39.031 1 25.5 1S1 11.969 1 25.5 11.969 50 25.5 50c.78 0 1.549-.04 2.31-.112L49.888 27.81c.071-.761.112-1.531.112-2.31" fill="#FBD88E" /><path d="M50 25.5C50 11.969 39.031 1 25.5 1S1 11.969 1 25.5 11.969 50 25.5 50c.78 0 1.549-.04 2.31-.112L49.888 27.81c.071-.761.112-1.531.112-2.31z" stroke="#7E94AA" strokeWidth={2} /><path d="M13.855 42.069a20.206 20.206 0 007.039 3.155 20.397 20.397 0 006.515.434m17.815-24.762a20.124 20.124 0 00-2.236-5.612C39.474 9.281 32.958 5.25 25.5 5.25c-11.184 0-20.25 9.066-20.25 20.25 0 5.336 2.063 10.19 5.436 13.807M45.658 27.41c.059-.63.092-1.266.092-1.91" stroke="#D8AB50" strokeWidth={2} /><path d="M27.922 49.888L50 27.81c-11.686 1.093-20.984 10.392-22.078 22.078" fill="#FFF" /><path d="M27.922 49.888L50 27.81c-11.686 1.093-20.984 10.392-22.078 22.078z" stroke="#7E94AA" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M25.948 23.923c-2.177 0-3.804-1.143-3.804-2.166 0-1.022 1.627-2.165 3.804-2.165 2.177 0 3.804 1.143 3.804 2.165a1.625 1.625 0 103.248 0c0-2.605-2.282-4.72-5.428-5.27v-1.768a1.625 1.625 0 10-3.248 0v1.768c-3.146.55-5.428 2.665-5.428 5.27 0 3.036 3.097 5.415 7.052 5.415.413 0 3.804 1.143 3.804 2.165 0 1.023-1.627 2.166-3.804 2.166-2.177 0-3.804-1.143-3.804-2.166a1.625 1.625 0 00-3.248 0c0 2.605 2.282 4.72 5.428 5.27v1.769a1.624 1.624 0 103.248 0v-1.768c3.146-.55 5.428-2.666 5.428-5.271 0-3.036-3.097-5.414-7.052-5.414" fill="#D8AB50" /></g></svg>
                                    )
                                }
                                {
                                    (item.shipping_type) === "custom_rates" && (
                                        <svg width={56} height={56} viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" focusable="false"><defs><path id="a" d="M0 54h54V0H0z" /></defs><g fill="none" fillRule="evenodd"><path d="M53 14H1V8.135C1 4.211 4.211 1 8.135 1h37.73C49.789 1 53 4.211 53 8.135V14z" fill="#CBE87C" /><path d="M53 14H1V8.135C1 4.211 4.211 1 8.135 1h37.73C49.789 1 53 4.211 53 8.135V14z" stroke="#7E94AA" strokeWidth={2} /><path d="M1 14h52v31.865C53 49.789 49.789 53 45.865 53H8.135C4.211 53 1 49.789 1 45.865V14z" fill="#ECF5FE" /><path d="M1 14h52v31.865C53 49.789 49.789 53 45.865 53H8.135C4.211 53 1 49.789 1 45.865V14z" stroke="#7E94AA" strokeWidth={2} /><path d="M1 23h51M2 33h51M2 43h51M35 14l.101 39M17.9 14l.1 39" stroke="#7E94AA" strokeWidth={2} opacity=".304" /><mask id="b" fill="#fff"><use xlinkHref="#a" /></mask><path fill="#FFF" mask="url(#b)" d="M35 33h18V23H35z" /><path stroke="#7E94AA" strokeWidth={2} mask="url(#b)" d="M35 33h18V23H35z" /></g></svg>
                                    )
                                }
                            </span>
                        </div>
                        <div className="card-text pad-12-L">
                            <div className="card-header_">
                                <Link to={`${storeUrl}/settings/shippings/edit-delivery-method/${e.id}`} className="d-flex text-decoration-none st-text-color d-inline-block">
                                    <span>{e.shipping_name}</span>
                                    <span className="edit-btn ms-2">
                                        <span className="st-fw-400 st-fs-12 st-text-primary">Edit</span>
                                    </span>
                                </Link>
                            </div>

                            <div className="card-description">
                                <p className="st-text-color">{rate}, { e.shipping_region || "United States" }</p>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <Dropdown className="st-bs-dropdown no-down-icon action-btn me-4"
                        >
                            <Dropdown.Toggle
                                className={`st-btn ${enabled === false ? "disabled" : "st-btn-white-gray-outlined"} st-btn-sm  align-items-center justify-content-center align-items-center`}
                            >
                                <span>Actions</span>
                                <FeatherIcon
                                    icon="chevron-down"
                                    size="15"
                                    className="icon"
                                />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Link
                                    disabled={true}
                                    to={`${storeUrl}/settings/shippings/edit-delivery-method/${e.id}`}
                                    className="text-decoration-none text-currentcolor">
                                    <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="d-none" />
                                        <span className="text ms-2">
                                            Edit
                                        </span>
                                    </label>
                                </Link>
                                {(e.shipping_name === "Сustom Rates" || e.shipping_name === "Conditional Free Shipping" || e.shipping_name === "Flat Rate") && <Link
                                    disabled={true}
                                    to={`/settings/shippings/edit-delivery-method/${e.id}`}
                                    className="text-decoration-none text-currentcolor">
                                    <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="d-none"
                                        />
                                        <span className="text ms-2">

                                            Change Rates
                                        </span>
                                    </label>
                                </Link>}
                                <Link
                                    disabled={true}
                                    to="/settings/shippings/sort-delivery"
                                    className="text-decoration-none text-currentcolor">
                                    <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="d-none"
                                        />
                                        <span className="text ms-2">
                                            Sort
                                        </span>
                                    </label>
                                </Link>

                                <Dropdown.Item
                                    className="dropdown-item st-checkbox d-inline-flex cursor-pointer"
                                    onClick={ev => { deleteShipping(e.id) }}
                                >

                                    <span className="text ms-2">Delete</span>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <div className="switch-btn">
                            <label className="st-switch-input-xs st-switch-success d-inline-flex align-items-center">
                                <input
                                    className="d-none"
                                    type="checkbox"
                                    name="switch"
                                    checked={enabled}
                                    onChange={ev => {
                                        e.status = ev.target.checked ? 1 : 0
                                        setEnabled(ev.target.checked)
                                        addShipping_(e)
                                    }}
                                />
                                <span className="round-outer">
                                    <span className="round d-block">
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function ShippingView(props) {
    const { loading, shippings, addShipping_, deleteShipping } = props

    return (
        <React.Fragment>
            <Row className="payment-content mb-3">
                <Col lg={3} md={12} className="product-filter-left-content">
                    <p className="product-filter-subheading">Current shipping and delivery methods</p>
                    <p className="product-filter-desc">
                        These are the shipping and delivery methods that you have added to your store. When enabled, they are available for customers to choose from at checkout.
                    </p>
                </Col>

                <Col lg={9} md={12} className="product-filter-right-content">
                    {loading ?
                        <div>
                            <LoadingSkeleton
                                height={100}
                            />
                            <LoadingSkeleton
                                height={100}
                            />
                            <LoadingSkeleton
                                height={100}
                            />
                            <LoadingSkeleton
                                height={100}
                            />
                        </div> :
                        <div>
                            {shippings.length > 0 ? shippings.map((e, index) =>
                                <ShippingRow
                                    key={e.id}
                                    item={e}
                                    deleteShipping={deleteShipping}
                                    addShipping_={addShipping_}
                                />
                            )
                                :
                                <div className={`product-filter-card `}>
                                    <div className="card-content justify-content-center">
                                        No Shipping is added yet.
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </Col>
            </Row>

            <Shipping
                loading={loading}
            />
            <LocalDelivery
                loading={loading}
            />
            <PickUp
                loading={loading}
            />
            <Row className="payment-content">
                {/* <Col lg={3} md={12} className="product-filter-left-content">
                    <p className="product-filter-subheading">Settings</p>
                </Col>
                <OriginAddress loading={loading} /> */}
            </Row>
            <Row className="payment-content">
                <Col lg={3} md={12} className="product-filter-left-content">
                </Col>
                <HandleFee
                    loading={loading}
                />
            </Row>
            {/* <Row className="payment-content" style={{ marginTop: 64 }}> */}
            <Row className="payment-content" style={{ marginTop: 30 }}>
                <Col lg={12} md={12} className="product-filter-left-content">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Tools</p>
                    </div>
                </Col>
                <Col lg={6} md={12} className="product-filter-right-content st-border-none">
                    <div className="app-card mb-3 mb-lg-4 add-criteria">
                        <div className="product-filter-card st-border-none">
                            <div className="card-text d-flex bg-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="97" height="89" viewBox="0 0 97 89" focusable="false">
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#2793CD" d="M96.92 47.78c-.39-.39-1.02-.39-1.41-.01L83.49 59.8l-6.36-6.36c-.39-.38-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.42l7.07 7.07c.39.39 1.02.39 1.41.01l.01-.01L96.93 49.2c.38-.39.38-1.03-.01-1.42z">
                                    </path>
                                    <path fill="#2793CD" d="M89 9.97H1l.03.03H1v60c0 2.21 1.79 4 4.01 4h79.98C87.2 74 89 72.21 89 70v-7.23l-1.98 1.98s-.01.01-.02.01V70c0 1.11-.9 2-2.01 2H5.01C3.9 72 3 71.1 3 70V12h.23L45 50l41.77-38H87v38.63l2-2V10h-.03l.03-.03zM45 47.29L6.2 12h77.6L45 47.29z">
                                    </path>
                                </svg>
                                <div className="ms-4">
                                    <div className="card-header_">
                                        <div className="text__dark-color st-fs-16 st-fw-600">Set up delivery status notifications</div>
                                        <div className="mt-2">Keep your customers updated on the status of their orders.</div>
                                    </div>

                                    <div className="mt-3">
                                        <button
                                            type="submit"
                                            className="st-btn st-btn-primary st-btn-sm d-flex align-items-center text-capitalize mt-2 justify-content-center d-flex"
                                            onClick={(e => { })}
                                        >
                                            <span className="st-fw-400">Set up Notifications</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment >
    )
}